import { gql } from '@apollo/client';

export const GET_ECD_PHOTOS_AND_RECOMMENDATION = gql`
  query GetEcdPhotosAndRecommendation($id: ID!) {
    otherPhotos: getEcdPhotosAndRecommendation(id: $id) {
      id
      recommendation

      buildingPhotos {
        id
        url
      }
      burglarSecurityPhotos {
        id
        url
      }
      electricitySetupPhotos {
        id
        url
      }
      fencePhotos {
        id
        url
      }
      gatePhotos {
        id
        url
      }
      handwashingFacilityPhotos {
        id
        url
      }
      kitchenPhotos {
        id
        url
      }
      officePhotos {
        id
        url
      }
      playgroundPhotos {
        id
        url
      }
      playroomPhotos {
        id
        url
      }
      refuseAreaPhotos {
        id
        url
      }
      roofPhotos {
        id
        url
      }
      sickroomPhotos {
        id
        url
      }
      sitePhotos {
        id
        url
      }
      storeroomPhotos {
        id
        url
      }
      toiletPhotos {
        id
        url
      }
      vegetableGardenPhotos {
        id
        url
      }
      waterSupplyPhotos {
        id
        url
      }
    }
  }
`;
